import axios from 'axios'
import {createAsyncThunk, PayloadAction, createAction, Action} from '@reduxjs/toolkit'
import { sliceStateStatus } from '../../../../Core';
import {routesIndex} from '@/RoutesIndex';
import IUser from '../../../../interface/core/IUser'
import ISliceState from '../../../../interface/core/ISliceState';
import { generatePaginationStateDataItem, generateUserStateDataItem } from '../../../hooks';
import IPagination from '../../../../interface/core/IPagination';
import ISearch from '../../../../interface/core/ISearch';
import { IType } from '../../../../interface/IType';

export const usersStore = createAsyncThunk(
  'users/store',
  async (_data:IUser, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
      }
   
      /*const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      }*/
       
      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.store;
      await axios.post(
        uri,
        _data,
        config
      );

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const usersIndex = createAsyncThunk(
  'users/index',
  async (_, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.index;
      const q = axios.get(uri, config);
      const r = (await q).data;

      return setStateData(r);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const usersView = createAsyncThunk(
  'users/view',
  async (_id:number | undefined, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.view;
      const q = axios.get(uri + '/' + _id, config);
      const r = (await q).data;

      return setStateData(r);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)
export const usersUpdate = createAsyncThunk(
  'users/update',
  async (_data:IUser, { rejectWithValue }) => {
    try {
     
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      }

      let url = routesIndex.api.prefix + '/user' + routesIndex.api.methods.profileinformation;
      const q = await axios.put(
        url,
        _data,
        config
      );

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)
export const usersDestroy = createAsyncThunk(
  'users/destroy',
  async (_data:IUser, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.destroy;
      await axios.post(
        uri,
        _data,
        config
      );

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)
export const usersCreate = createAsyncThunk(
  'users/create',
  async (_data:IUser, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
      }
   
      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.create;
      await axios.post(
        uri,
        _data,
        config
      );

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)
export const usersActivate = createAsyncThunk(
  'users/activate',
  async (_data:IUser, { rejectWithValue }) => {
    try {

      /*
      const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
      }
      */
     
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.activate;
      await axios.put(
        uri,
        _data,
        config
      );

    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
)



export const usersSearch = createAsyncThunk(
  'users/search',
  async (_data:ISearch | undefined, { rejectWithValue }) => {
    try {
      
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
      };

      let params = _data!.params as IUser;
      
      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.search;
      if(_data!.page && parseInt(_data!.page) > 1) {
        uri += '?page='+_data!.page;
      }

      const q = axios.post(
        uri, 
        params,
        config
      );
      const r = (await q).data;

      return setStateData(r, true);

    } catch (error: any) {
      if (error.response && error.response.data.message) {
        throw rejectWithValue(error.response.data.message);
      } else {
        throw rejectWithValue(error.message);
      }
    }
  }
); 
export const usersPaginate = createAsyncThunk(
  'users/paginate',
  async (page: string, { rejectWithValue }) => {
    try {

      const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
      }

      let uri = routesIndex.api.prefix + routesIndex.api.users + routesIndex.api.methods.paginate;
      if(page && parseInt(page) > 1) {
        uri = uri +'?page='+page;
      }

      const q = axios.get(uri, config);
      const r = (await q).data;
      
      return setStateData(r, true);
    }
    catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      }
      else {
        return rejectWithValue(error.message)
      }
    }
  }
);

export const setUserData = createAction<IUser>('setUserData')
export const removeUserData = createAction('removeUserData')

export const usersReset = createAction('usersReset')




const setStateData = (apiResponse: any, paginate: boolean = false) => {

  let stateData: ISliceState = {
    data: new Array<IUser>(),
    status: sliceStateStatus.fulfilled
  };

  if(apiResponse.status && apiResponse.result) {

    if(paginate) {
      stateData.data = {} as IPagination;
      Object.assign(stateData.data, generatePaginationStateDataItem(apiResponse.result, IType.user));
    }
    else {
      if(Array.isArray(apiResponse.result)) {
        apiResponse.result.map((a: any, i: number) => (
          stateData.data.push(
            generateUserStateDataItem(a)
          )
        ))
      }
      else {
        stateData.data = {} as IUser;
        Object.assign(stateData.data, generateUserStateDataItem(apiResponse.result));
      } 
    }
  }
  
  return stateData;
};